import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  media: {
    marginTop: 16
  }
})

export default useStyles
